import { OnInit, Renderer2 } from '@angular/core';
import { CsAgGridJsService } from '@app/shared/cs-ag-grid-js/cs-ag-grid-js.service';
var CsAgGridDetailCellRendererComponent = /** @class */ (function () {
    function CsAgGridDetailCellRendererComponent(_renderer, _csAgGrid) {
        var _this = this;
        this._renderer = _renderer;
        this._csAgGrid = _csAgGrid;
        this.toggleOnWholeCell = false;
        this.updateCellValue = function (rowData) {
            _this._csAgGrid.updateNodeCellValue(_this.rowNode, rowData);
        };
    }
    CsAgGridDetailCellRendererComponent.prototype.ngOnInit = function () {
        this.rowNode = this.params.node;
        this.colId = this.params.column.getColId();
        this.toggleOnWholeCell = this.params.toggleOnWholeCell || false;
    };
    Object.defineProperty(CsAgGridDetailCellRendererComponent.prototype, "isCellExpanded", {
        get: function () {
            var isExpanded = this.rowNode['expandedColId'] === this.colId;
            this.setCellExpansionClass(isExpanded);
            return isExpanded;
        },
        enumerable: true,
        configurable: true
    });
    CsAgGridDetailCellRendererComponent.prototype.toggleDetailGrid = function () {
        if (this.rowNode.expanded) {
            if (this.rowNode['expandedColId'] !== this.colId) {
                this.rowNode.setExpanded(false);
                this.rowNode['expandedColId'] = null;
                this.setDetailData();
            }
        }
        else {
            this.setDetailData();
        }
        this.setExpanded();
    };
    CsAgGridDetailCellRendererComponent.prototype.setExpanded = function () {
        this.rowNode.setExpanded(!this.rowNode.expanded);
        this.params.api.refreshCells();
        this.rowNode['expandedColId'] = this.rowNode.expanded ? this.colId : null;
    };
    CsAgGridDetailCellRendererComponent.prototype.setDetailData = function () {
        this.rowNode['detailMetaData'] = {
            data: this.rowNode.data,
            colId: this.colId,
            rowNode: this.rowNode,
            updateCellValue: this.updateCellValue
        };
    };
    CsAgGridDetailCellRendererComponent.prototype.setCellExpansionClass = function (isExpanded) {
        this._renderer[isExpanded ? 'addClass' : 'removeClass'](this.params.eGridCell, 'cell-expanded');
    };
    return CsAgGridDetailCellRendererComponent;
}());
export { CsAgGridDetailCellRendererComponent };
